import React from "react";
import * as Material from "@mui/material";
import { Percent } from "@mui/icons-material";

import styles from "./styles.scss";

import { Text } from "@fragments";
import Parser from "@helpers/parser.js";

export default function Taxes({ wallet, loading }) {

    if (loading) {
        return (
            <div className="withdrawals-taxes-card mt-3 mb-5">
                <Text.h4 weight={500}>
                    Taxas
                </Text.h4>
                <div className="taxes-card mt-2">
                    <Material.Skeleton
                        variant="rounded"
                        width={56}
                        height={56}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            '&::after': {
                                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
                            }
                        }}
                    />
                    <div className="right-section" style={{ gap: '8px' }}>
                        <Material.Skeleton
                            variant="rounded"
                            width={150}
                            height={20}
                            sx={{
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                '&::after': {
                                    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
                                }
                            }}
                        />
                        <Material.Skeleton
                            variant="rounded"
                            width={120}
                            height={20}
                            sx={{
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                '&::after': {
                                    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }

    if (!wallet?.taxes) return null;

    const { taxes } = wallet;

    return (
        <div className="withdrawals-taxes-card mt-3 mb-5">
            <Text.h4 weight={300} contrast={9}>
                Taxas da conta
            </Text.h4>

            <div className="taxes-card mt-1">
                <div className="left-section">
                    <Percent className="taxes-icon" />
                </div>

                <div className="right-section">
                    <div className="info-row">
                        <Text.span contrast={7}>
                            Taxa por venda:
                        </Text.span>
                        <Text.span weight={500} contrast={7}>
                            {taxes.percentile}% + R$ {Parser.price.brl(taxes.fixed)}
                        </Text.span>
                    </div>

                    <div className="info-row">
                        <Text.span contrast={7}>
                            Taxa de parcelamento:
                        </Text.span>
                        <Text.span weight={500} contrast={7}>
                            {taxes.anticipation}%
                        </Text.span>
                        <Text.span contrast={7}>
                            ao mês por parcela
                        </Text.span>
                    </div>
                </div>
            </div>
        </div>
    )
}
